import React from 'react';
import {useSelector} from 'react-redux';

// Selectors
import {hotelDetailsSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

// Types
import {FaqData} from '@stencil/hotels-types/src/details-cg/types/static';

// components
import FaqsUI from '@stencil/gi-components/src/SeoFaqs/Faqs';

const Faqs = () => {
  const {faqData = {} as FaqData, name = ''} = useSelector(hotelDetailsSelector) || {};
  return <FaqsUI faqData={faqData} name={name} />;
};

export default Faqs;
